export default {
  'state': '경기종료! 최종 우승은 지도영님',
  'players': [{
    'id': 'a',
    'name': '쿵쿵',
    'avatar': 'Wendy',
    'score': 0,
    'rank': 1,
    'team': 'red',
    'editTeam': null,
    'href': 'https://www.twitch.tv/kung_3'
  }, {
    'id': 'b',
    'name': '장기코',
    'avatar': 'Wilson',
    'href': 'https://www.twitch.tv/wkdrlzh',
    'score': 30,
    'rank': 2,
    'team': 'blue',
    'editTeam': null
  }, {
    'id': 'c',
    'name': '김위그',
    'avatar': 'Wigfrid',
    'score': 10,
    'rank': 3,
    'team': 'blue',
    'editTeam': null
  }, {
    'id': 'd',
    'name': '지도영',
    'avatar': 'Wurt',
    'score': 0,
    'rank': 4,
    'team': 'red',
    'editTeam': null
  }, {
    'id': 'e',
    'name': '918',
    'avatar': 'Wickerbottom',
    'href': 'https://www.twitch.tv/918ab',
    'score': 0,
    'rank': 5,
    'team': 'blue',
    'editTeam': null
  }, {
    'id': 'f',
    'name': '명데',
    'avatar': 'WX-78',
    'href': 'https://www.twitch.tv/myoungday',
    'score': 0,
    'rank': 6,
    'team': 'red',
    'editTeam': null
  }],
  'team': {
    'red': {
      'players': ['a', 'f', 'd']
    },
    'blue': {
      'players': ['b', 'e', 'c']
    }
  },
  'prize': {
    'personal': [{
      'img': '/static/img/prize/cam.jpg',
      'name': '포인트 무료 사용권',
      'href': 'https://www.twitch.tv/myoungday'
    }, {
      'img': '/static/img/prize/10000.jpg',
      'name': '문화상품권 10000원'
    }, {
      'img': '/static/img/prize/5000.jpg',
      'name': '문화상품권 5000원'
    }],
    'team': [{
      'img': '/static/img/prize/bbq.png',
      'name': 'BBQ 치킨',
      'href': 'https://www.bbq.co.kr/main.asp'
    }, {
      'img': '/static/img/prize/puradak.png',
      'name': '푸라닥 치킨',
      'href': 'http://puradakchicken.com/'
    }]
  },
  'mission': [{
    'code': 'beefalo',
    'type': 'main',
    'name': '비팔로 경주',
    'img': '/static/img/beefalo.png',
    'desc': '비팔로를 타고 각자 주어진 미션 수행하기',
    'scores': [30, 20, 10],
    'winner': ['c', 'd', 'b'],
    'completed': true
  }, {
    'code': 'wx-78',
    'type': 'sub',
    'name': 'WX-78',
    'img': '/static/img/gears.png',
    'desc': '기어 먹고 심장 많이 만들기',
    'character': 'WX-78',
    'scores': [10],
    'winner': ['d', '', ''],
    'completed': true
  }, {
    'code': 'warly',
    'type': 'sub',
    'name': '왈리',
    'img': '/static/img/crock_pot.png',
    'desc': '시간 내에 음식 많이 만들기',
    'descDetail': ['신선한 과일 크레페', '감자 수플레', '아스파라거즈파초', '용과 칠리 샐러드', '번개 염소 푸딩', '피쉬 꼬르동 블루', '발광베리 무스'],
    'character': 'Warly',
    'scores': [10],
    'winner': ['d'],
    'completed': true
  }, {
    'code': 'boat',
    'type': 'main',
    'name': '수영',
    'img': '/static/img/boat.png',
    'location': '달섬 기준으로 왕복해서 갈 수 있는 곳',
    'desc': '배를 타고 먼저 임무 수행하기',
    'scores': [30, 20, 10],
    'winner': ['d', 'b', 'f'],
    'completed': true
  }, {
    'code': 'woodie',
    'type': 'sub',
    'name': '우디',
    'img': '/static/img/log.png',
    'desc': '비버로 나무 제일 많이 모으기',
    'descDetail': '16분 제한',
    'character': 'Woodie',
    'scores': [10],
    'winner': [],
    'completed': true
  }, {
    'code': 'webber',
    'type': 'sub',
    'name': '웨버',
    'img': '/static/img/silk.png',
    'desc': '거미줄 더 많이 모으기',
    'character': 'Webber',
    'scores': [10],
    'winner': [],
    'completed': true
  }, {
    'code': 'pvp',
    'type': 'main',
    'name': 'PVP',
    'img': '/static/img/pvp.png',
    'desc': '3:3 팀전',
    'descDetail': ['무기, 방어구 직접 선택'],
    'location': '사바나 지역 콜로세움',
    'scores': [30, 30, 30],
    'winner': ['d', 'b', 'c'],
    'completed': true
  }, {
    'code': 'special',
    'type': 'sub',
    'name': '특별게임',
    'img': '/static/img/monster_meat.png',
    'desc': '명데와 짝꿍되기',
    'character': 'Woodie',
    'scores': [50, 30],
    'winner': [],
    'completed': true
  }, {
    'code': 'willow',
    'type': 'sub',
    'name': '윌로우',
    'img': '/static/img/lighter.png',
    'desc': '밤에 누가 오래 살아남나',
    'character': 'Willow',
    'descDetail': ['주위 물건 태우기 X', '반딧불 사용 X'],
    'scores': [10],
    'winner': ['d'],
    'completed': true
  }]
}



// WEBPACK FOOTER //
// ./src/assets/snapshot.js